import React, { useState, useEffect, useRef } from "react";
import styles from "./Dropdown.module.css";

const Dropdown = (props) => {
  const list = props.props.data;
  const onChange = props.props.onChange;
  // value: 선택된 값을 밖에서 정할 때 (없으면 첫 항목), width: 기본 너비 대신 쓸 너비
  const value = props.props.value;
  const width = props.props.width;
  const selectRef = useRef(null);
  const [currentValue, setCurrentValue] = useState(value ?? list[0]);
  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    if (value !== undefined) setCurrentValue(value);
  }, [value]);

  const handleOnChangeSelectValue = (e) => {
    const selected = e.target.getAttribute("value");
    // 값을 밖에서 정하는 경우(value)는 밖에서 바뀔 때 따라감
    if (value === undefined) setCurrentValue(selected);
    if (onChange) onChange(selected);
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectRef]);

  return (
    <div
      className={styles.selectBox}
      style={width ? { width } : undefined}
      onClick={() => setShowOptions((prev) => !prev)}
      ref={selectRef}
    >
      <label className={styles.label}>{currentValue}</label>
      <ul className={`${styles.selectOptions} ${showOptions ? styles.show : styles.hide}`}>
        {list.map((data, index) => (
          <li
            key={index}
            className={styles.option}
            value={data}
            onClick={handleOnChangeSelectValue}
          >
            {data}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Dropdown;
